import React, { useCallback, useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Input, TitleComponent, MousePositionedTooltip } from '@keen.io/ui-core';
import { Wrapper } from './Limit.styles';
import { setLimit, getLimit, getGroupBy, getOrderBy } from '../../modules/query';
import { AppContext } from '../../contexts';
import { colors } from '@keen.io/colors';
import { BodyText } from '@keen.io/typography';

var Limit = function Limit(_ref) {
  var collection = _ref.collection;
  var dispatch = useDispatch();

  var _useContext = useContext(AppContext),
      modalContainer = _useContext.modalContainer;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var limit = useSelector(getLimit);
  var groupBy = useSelector(getGroupBy);
  var orderBy = useSelector(getOrderBy);
  var isDisabled = !groupBy || !orderBy || !orderBy.length;
  var changeHandler = useCallback(function (eventValue) {
    if (eventValue) {
      var limitValue = parseInt(eventValue);
      dispatch(setLimit(limitValue));
    } else {
      dispatch(setLimit(undefined));
    }
  }, []);
  useEffect(function () {
    return function () {
      dispatch(setLimit(undefined));
    };
  }, []);
  useEffect(function () {
    if (isDisabled) {
      dispatch(setLimit(undefined));
    }
  }, [isDisabled]);

  var selectAndOrderDataTooltip = function selectAndOrderDataTooltip() {
    return React.createElement(BodyText, {
      variant: "body2",
      fontWeight: "normal",
      color: colors.white[500]
    }, collection ? React.createElement("span", {
      "data-testid": "order-data-tooltip"
    }, React.createElement("strong", null, t('query_creator_limit.order')), ' ', t('query_creator_limit.limit_result')) : React.createElement("span", {
      "data-testid": "select-event-stream-tooltip"
    }, t('query_creator_limit.select'), ' ', React.createElement("strong", null, t('query_creator_limit.event_stream')), ' ', t('query_creator_limit.tooltip')));
  };

  return React.createElement(React.Fragment, null, React.createElement(TitleComponent, {
    isDisabled: isDisabled
  }, t('query_creator_limit.label')), React.createElement(MousePositionedTooltip, {
    isActive: isDisabled,
    tooltipTheme: "dark",
    tooltipPortal: modalContainer,
    renderContent: selectAndOrderDataTooltip
  }, React.createElement(Wrapper, {
    "data-testid": "limit-wrapper"
  }, React.createElement(Input, {
    disabled: isDisabled,
    type: "number",
    variant: "solid",
    "data-testid": "limit",
    id: "limit",
    placeholder: t('query_creator_limit.placeholder'),
    value: limit ? limit : '',
    onChange: function onChange(e) {
      return changeHandler(e.target.value);
    }
  }))));
};

export default Limit;